<template lang="pug">
info-card(
  :title='$t("modal.envelope.envelopeInfo")'
  icon='envelope'
  icon-color='blue'
)
  ul.nav.flex-column.info-card-list
    li(v-if='envelope.title')
      small.text {{ $t('modal.envelope.envelopeName') }}: {{ envelope.title }}
    li(v-if='envelope.subject')
      small.text {{ $t('modal.envelope.subject') }}: {{ envelope.subject }}
    li(v-if='envelope.created_at')
      small.text {{ $t('modal.envelope.sentAt') }}: {{ envelope.created_at | date }}
    li(v-if='envelope.sender')
      small.text {{ $t('modal.envelope.sentBy') }}: {{ envelope.sender.name }} ({{ envelope.sender.email }})
    li(v-if='envelope.state')
      small.text.me-1 {{ $t('modal.envelope.envelopeStatus') }}:
      status-badge(:status='envelope.state')
    li(v-if='envelope.expire_at')
      small.text {{ $t('modal.envelope.signatureDeadline') }}: {{ envelope.expire_at | date }}
    li(v-if='envelope.effective_date_reminder_at')
      small.text {{ $t('modal.envelope.envelopeExpiration') }}: {{ envelope.effective_date_reminder_at | date }}
    li(v-if='envelope.effective_date_reminder_at')
      small.text {{ $t('modal.envelope.expirationNotification') }}: {{ daysForNotification }} {{ $t('modal.envelope.daysBefore') }}
  signatures-summary-badge.mt-3(
    :count='signaturesSummary.count'
    :total='signaturesSummary.total'
    personal
    v-if='signaturesSummary'
  )
</template>

<script>
import InfoCard from '@/modules/business/components/molecules/InfoCard.vue';
import StatusBadge from '@/modules/business/components/molecules/StatusBadge.vue';
import SignaturesSummaryBadge from '@/modules/business/components/molecules/SignaturesSummaryBadge.vue';

export default {
  name: 'EnvelopeInfoCard',
  components: {
    InfoCard,
    StatusBadge,
    SignaturesSummaryBadge,
  },
  props: {
    envelope: {
      type: Object,
      required: true,
    },
    daysForNotification: {
      type: Number,
      default: null,
    },
    signaturesSummary: {
      type: Object,
      default: null,
    },
  },
};
</script>
